import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

export const Row = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;

export const Container = styled.div<{ $backgroundColor: string }>`
  display: inline-block;
  padding: 2px 6px 3px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 4px;
`;

export const BadgeText = styled.p`
  font-weight: 600;
  color: ${(props) => props.theme.white};
  font-size: 12px;
`;

export const Placeholder = styled.div<{ $useWideDisplay?: boolean }>`
  ${({ $useWideDisplay }) =>
    $useWideDisplay
      ? css`
          @media (${mobileXXLargeMax}) {
            padding-bottom: 30px;
          }
        `
      : css`
          padding-bottom: 30px;
        `}
`;
